import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, timer } from 'rxjs';
import { Router } from '@angular/router';
import { urlApi } from '../../../utils/apiConfig';


@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  constructor(private http: HttpClient, private router: Router) {
    
   }

  public authService(): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(urlApi + '/admin/verifiedlogin', null, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('token') ?? ''
      },
      observe: 'response' 
    });
  }

  requestDataPeriodicallyAdmin(): Observable<any> {
    return timer(0, 20000).pipe(
      switchMap(() => this.http.post(urlApi+'/admin/verifiedlogin', null, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') || ''}}))
    );
  }

  public logout(){
    localStorage.clear();
    this.router.navigate(['/admin']);
  }
}
